import React from "react";

import ChevronDownSVG from "./svgComponents/chevronDownSVG";
import ChevronUpSVG from "./svgComponents/chevronUpSVG";
import ResultsSVG from "./svgComponents/resultsSVG";
import SearchSVG from "./svgComponents/searchSVG";
import SettingsSVG from "./svgComponents/settingsSVG";
import StatusErrorSVG from "./svgComponents/statusErrorSVG";
import StatusOkSVG from "./svgComponents/statusOkSVG";
import SupportSVG from "./svgComponents/supportSVG";
import UsersSVG from "./svgComponents/usersSVG";
import WarningSVG from "./svgComponents/warningSVG";
import { Icon } from "./Icon";

export const WarningIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <WarningSVG />
  </Icon>
);

export const ResultsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <ResultsSVG />
  </Icon>
);

export const UsersIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <UsersSVG />
  </Icon>
);

export const SettingsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <SettingsSVG />
  </Icon>
);

export const ChevronDownIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <ChevronDownSVG />
  </Icon>
);

export const ChevronUpIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <ChevronUpSVG />
  </Icon>
);

export const SupportIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <SupportSVG />
  </Icon>
);

export const StatusOkIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className} $selfColoured>
    <StatusOkSVG />
  </Icon>
);

export const StatusErrorIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <StatusErrorSVG />
  </Icon>
);
export const SearchIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon className={className}>
    <SearchSVG />
  </Icon>
);
